import styled from 'styled-components';
import { UserPlus } from '@styled-icons/fa-solid/UserPlus';
import { Button } from 'antd';

export const ResponsiblesContainer = styled.div``;

export const ResponsibleItemContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
  transition: opacity 0.5s;
  position: relative;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: row;
  }

  &.remove-element {
    opacity: 0;
  }

  animation: newItem 1s ease;
  @keyframes newItem {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 0.75;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const ConstructionDataInputContainer = styled.div`
  flex-grow: 1;
  margin-bottom: 0.5rem;
  position: relative;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    align-self: flex-end;
    margin-bottom: 0;

    &:not(:last-child) {
      margin-right: 1.5rem;
    }
  }

  & > .title {
    color: ${({ theme }) => theme.colors.grayDark2};
    font-weight: bold;
    font-size: 0.875rem;
  }

  & > input {
    &.error {
      border-color: ${({ theme }) => theme.colors.red};
    }
  }
`;

export const InputErrorMessage = styled.span`
  font-size: 0.75rem;
  color: ${({ theme }) => theme.colors.red};
  padding-left: 0.5rem;
  animation: topToBottom 0.15s ease-in-out;

  @keyframes topToBottom {
    0% {
      top: 90%;
      opacity: 0.25;
    }
    100% {
      top: 100%;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    position: absolute;
    left: 0;
    bottom: -1.25rem;
  }
`;

export const AddResponsibleButton = styled(Button)`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.blue4};
  font-weight: 700;
`;

export const UserPlusIcon = styled(UserPlus)`
  width: 1rem;
  margin-right: 0.5rem;
`;

export const CollapsePannelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const AddResponsibleButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  height: 5rem;
`;
